export enum UserType {
  RegularUser = 'regular-user',
  MultiUser = 'multi-user',
  BoUser = 'bo-user',
}
